import axios from 'axios'
import YAML from 'yaml'

import parse from './parser'

export default async function load (games) {
  const responses = await Promise.all(games.map(game => axios.get(url(game))))
  const yamls = responses.map(response => response.data)
  const jsons = yamls.map(yaml => YAML.parse(yaml, { merge: true, simpleKeys: true }))
  const rulebook = parse(jsons)
  return rulebook
}

function url (game) {
  const [gameName, rulebook] = game.split(' ')
  return `https://raw.githubusercontent.com/rpg-apps/rpg-yaml/master/games/${gameName}/${rulebook}.yml`
}
